<template>
    <ErrorModal v-if="type === ModalType.Error" v-bind="props" />
    <ProductModal v-if="type === ModalType.Product" v-bind="props" />
    <PriceGuaranteeModal v-if="type === ModalType.PriceGuarantee" v-bind="props" />
    <DeleteProductModal v-if="type === ModalType.DeleteProduct" v-bind="props" />
    <ProductCancellationModal v-if="type === ModalType.ProductCancellation" v-bind="props" />
    <PassportExamplesModal v-if="type === ModalType.PassportExamples" v-bind="props" />
    <AgentMediationModal v-if="type === ModalType.AgentMediation" v-bind="props" />
    <SupplierNotesModal v-if="type === ModalType.SupplierNotes" v-bind="props" />
    <CouponModal v-if="type === ModalType.Coupon" v-bind="props" />
    <BaggageWarningModal v-if="type === ModalType.BaggageWarning" v-bind="props" />
    <DuplicatePaxWarning v-if="type === ModalType.DuplicatePaxWarning" v-bind="props" />
    <WelcomeSembonusModal v-if="type === ModalType.WelcomeSembonus" />
    <ServicePackage v-if="type === ModalType.ServicePackage" />
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent } from 'vue';
    import { useStore } from '@/store';
    import { ModalType } from '@/store/general/types';
    import ErrorModal from './Variants/Error/Error.vue';
    import PriceGuaranteeModal from './Variants/PriceGuarantee/PriceGuarantee.vue';
    import PassportExamplesModal from '@/components/modals/Variants/PassportExamples/PassportExamples.vue';
    import AgentMediationModal from '@/components/modals/Variants/AgentMediation/AgentMediation.vue';
    import DeleteProductModal from '@/components/modals/Variants/DeleteProduct/DeleteProduct.vue';
    import ProductCancellationModal from './Variants/ProductCancellation/ProductCancellation.vue';
    import ProductModal from './Variants/Product/Product.vue';
    import SupplierNotesModal from './Variants/SupplierNotes/SupplierNotes.vue';
    import CouponModal from './Variants/Coupon/Coupon.vue';
    import BaggageWarningModal from './Variants/BaggageWarning/BaggageWarning.vue';
    import WelcomeSembonusModal from './Variants/WelcomeSembonus/WelcomeSembonus.vue';
    import DuplicatePaxWarning from '@/components/modals/Variants/DuplicatePaxWarning/DuplicatePaxWarning.vue';
    import ServicePackage from '@/components/modals/Variants/ServicePackage/ServicePackage.vue';

    export default defineComponent({
        name: 'Modals',
        methods: { t },
        components: {
            DeleteProductModal,
            ErrorModal,
            ProductModal,
            PriceGuaranteeModal,
            PassportExamplesModal,
            ProductCancellationModal,
            AgentMediationModal,
            SupplierNotesModal,
            CouponModal,
            BaggageWarningModal,
            DuplicatePaxWarning,
            WelcomeSembonusModal,
            ServicePackage,
        },
        setup() {
            const store = useStore();

            const modal = computed(() => store.getters['general/getModal']);
            const type = computed(() => modal.value?.type);

            const props = computed(() => ({
                ...modal.value,
                onClose,
            }));

            function onClose() {
                store.dispatch('general/setModal', null);
            }

            return {
                ModalType,
                type,
                props,
            };
        },
    });
</script>
